import React from "react";
import { required } from "ra-core";
import { DebouncedTextInput } from "ra-friendsofbabba";

const ResultDetailsInput = ({ ...props }) => {
  const optionalRequired = () => (value, values) =>
    values.result_type_id > 0 ? required()(value, values) : undefined;

  return (
    <DebouncedTextInput
      {...props}
      maxLength={1000}
      multiline
      fullWidth
      validate={optionalRequired()}
    />
  );
};

export default ResultDetailsInput;
